export default __webpack_public_path__ + "static/media/trezza-devV1.7e17393a.png";